export default __webpack_public_path__ + "static/media/SIP-Calculator.51ced54e.png";